import loadable from '@loadable/component';
import { WithLazyHydration } from '../WithLazyHydration';

const NowOnTvLoadable = loadable(() => import('./NowOnTv'), {
  resolveComponent: components => components.NowOnTv
});

export const NowOnTv = WithLazyHydration(NowOnTvLoadable, {
  name: 'NowOnTv'
});
